var exports = {
  "Nr": "DiscoveryGuildCard.module__card___eUUzaG",
  "L8": "DiscoveryGuildCard.module__cardButton___eUUzaG",
  "vK": "DiscoveryGuildCard.module__banner___eUUzaG",
  "_e": "DiscoveryGuildCard.module__bannerImage___eUUzaG",
  "Dw": "DiscoveryGuildCard.module__bannerScrim___eUUzaG",
  "Kk": "DiscoveryGuildCard.module__icon___eUUzaG",
  "rf": "DiscoveryGuildCard.module__body___eUUzaG",
  "$": "DiscoveryGuildCard.module__titleRow___eUUzaG",
  "fh": "DiscoveryGuildCard.module__nameText___eUUzaG",
  "h_": "DiscoveryGuildCard.module__description___eUUzaG",
  "qr": "DiscoveryGuildCard.module__footer___eUUzaG",
  "dJ": "DiscoveryGuildCard.module__stat___eUUzaG",
  "rR": "DiscoveryGuildCard.module__statDotOnline___eUUzaG" + " " + "DiscoveryGuildCard.module__statDot___eUUzaG",
  "rb": "DiscoveryGuildCard.module__statDotMembers___eUUzaG" + " " + "DiscoveryGuildCard.module__statDot___eUUzaG",
  "KA": "DiscoveryGuildCard.module__statText___eUUzaG",
};

module.exports = exports;
